import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("admin_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const WHATSAPP_NUMBER = "917719693033"; // Display / click-to-chat
export const WHATSAPP_URL = (msg = "") =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
    msg || "Namaste Advocate Shubham Makkar, I need legal help. Please call me."
  )}`;
